import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import CheckCircleRounded from '@mui/icons-material/CheckCircleRounded';
import CancelOutlined from '@mui/icons-material/CancelOutlined';
import { COLORS } from '../marketingLeadConstants';

export function PillBadge({ label, color, bgColor, borderColor, icon: Icon }) {
  const isDark = bgColor === '#111111';
  const textColor = isDark ? '#FFFFFF' : color;
  return (
    <Box
      component='span'
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        bgcolor: bgColor,
        color: textColor,
        border: `1px solid ${borderColor || color + '33'}`,
        borderRadius: '100px',
        px: 1.25,
        py: 0.45,
        fontSize: 11.5,
        fontFamily: 'Inter Bold, sans-serif',
        fontWeight: 600,
        letterSpacing: '0.02em',
        lineHeight: 1.4,
        whiteSpace: 'nowrap',
      }}
    >
      {Icon && <Icon sx={{ fontSize: 12, color: textColor }} />}
      {label}
    </Box>
  );
}

export function StatusBadge({ status }) {
  const s = String(status ?? '').toLowerCase();
  if (s === 'onboarded' || s === 'active') {
    return (
      <PillBadge label={status} color='#111111' bgColor='#111111' borderColor='#111111' icon={CheckCircleRounded} />
    );
  }
  if (s.includes('failed') || s.includes('reject')) {
    return (
      <PillBadge label={status} color='#6B7280' bgColor='#F3F4F6' borderColor='#E5E7EB' icon={CancelOutlined} />
    );
  }
  if (s.includes('progress')) {
    return (
      <PillBadge label={status} color='#374151' bgColor='#EBEBEB' borderColor='#D4D4D4' />
    );
  }
  if (s.includes('contacted')) {
    return (
      <PillBadge label={status} color='#374151' bgColor='#F3F4F6' borderColor='#E5E7EB' icon={CheckCircleRounded} />
    );
  }
  return (
    <PillBadge label={status} color='#8C8C8C' bgColor='#F9FAFB' borderColor='#E8E8E8' />
  );
}

export function AddressCell({ text }) {
  return (
    <Tooltip title={text || ''} placement='top' enterDelay={350} arrow>
      <Typography
        sx={{
          fontFamily: 'Inter Regular, sans-serif',
          fontSize: 13,
          color: COLORS.muted,
          maxWidth: '100%',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          cursor: 'default',
          lineHeight: 1.5,
        }}
      >
        {text || '—'}
      </Typography>
    </Tooltip>
  );
}
